import { useTheme } from 'styled-components';

import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const MinusIcon: React.FC<SvgIconDefaultProps> = ({
  className,
  testId = 'minusIcon',
  color,
}) => {
  const { colors } = useTheme();
  const iconColor = color ? color : colors.interactive.brandColor;

  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="17"
      height="3"
      viewBox="0 0 17 3"
      fill="none"
    >
      <path
        d="M1 1.5H16"
        stroke={iconColor}
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </CustomSvg>
  );
};
export default MinusIcon;
